import {Component, OnInit} from '@angular/core';
import {UtilsService} from '../../../services/utils.service';
import {Router} from '@angular/router';
import {LanguageService} from '../../../services/language.service';

@Component({
  selector: 'app-new-language',
  templateUrl: './new-language.component.html',
  styleUrls: ['./new-language.component.scss']
})
export class NewLanguageComponent implements OnInit {

  language = {
    name: ''
  };
  languageError;
  constructor(private graphqlService: LanguageService,
              private utilsService: UtilsService,
              private router: Router) {
  }

  ngOnInit() {

  }

  addLanguage() {
    const requiredSuccess = this.utilsService.validateRequiredFields(this.language.name);
    if (requiredSuccess) {
      this.graphqlService.create(this.language).subscribe((response) => {
        if (response.errors && response.errors.length > 0) {
          const errors = response.errors.map(err => err.message);
          this.utilsService.openSnackBar(errors, '');
        } else {
          this.utilsService.openSnackBar('Language Created !!', '');
          this.router.navigate(['/languages']);
        }
      }, (error) => {
        this.utilsService.openSnackBar('Unable to create language.', '');
        console.log('there was an error sending the query', error);
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/components/languages/new-language/new-language.component.ts